<!--<div-->
<!--  class="page-wrapper scroll-brand"-->
<!--&gt;-->
<!--  <ngx-spinner-->
<!--    bdColor="rgba(58,63,81,0.8)"-->
<!--    size="medium"-->
<!--    color="#fff"-->
<!--    type="ball-clip-rotate-pulse"-->
<!--    name="innerSpinner"-->
<!--  ></ngx-spinner>-->
<!--  <div class="dam-tab-grid" [nbSpinner]="loading" nbSpinnerStatus="info">-->
<!--    <div-->
<!--      class="section"-->
<!--    >-->
<!--      <span-->
<!--        class="section-tittle"-->
<!--      >-->
<!--        System Template Feature Group-->

<!--        <button-->
<!--          class="btn-expand"-->
<!--        >-->
<!--          <img-->
<!--            class="btn-expand__icon filter-grey-sec"-->
<!--            ngSrc="assets/icons/chevron-down.svg" alt=""-->
<!--            width="20px"-->
<!--            height="20px"-->
<!--          >-->
<!--        </button>-->
<!--      </span>-->

<!--      <hr class="divider-horizontal">-->

<!--      <div *ngFor="let feature of features; index as i" class="row">-->
<!--        <div class="row-header">-->
<!--          <span class="clr-black-sec fs-10 fw-600">{{ feature.tittle }}</span>-->
<!--          <span class="clr-black-sec fs-10 fw-600 underline">#{{ feature.id }}</span>-->
<!--        </div>-->

<!--        <div-->
<!--          class="dropdown-container"-->
<!--        >-->
<!--          <app-feature-multiselect-->
<!--            [index]="i"-->
<!--            [name]="'feature-multiselect-test'"-->
<!--            [testItems]="feature.items"-->
<!--            [isValid]="feature.isValid"-->
<!--          >-->
<!--          </app-feature-multiselect>-->
<!--        </div>-->
<!--      </div>-->

<!--    </div>-->
<!--    <div-->
<!--      class="section g-16"-->
<!--    >-->
<!--      <div class="flex">-->
<!--        <span-->
<!--          class="section-tittle "-->
<!--        >-->
<!--          System Template-->
<!--        </span>-->

<!--        <span>-->
<!--          перейти к шаблону-->
<!--          <img-->
<!--            ngSrc="assets/icons/external-link.svg" alt=""-->
<!--            width="20px"-->
<!--            height="20px"-->
<!--          >-->
<!--        </span>-->
<!--      </div>-->

<!--      <span>-->
<!--        Последние изменения 11.12.2024 18:45:02-->
<!--      </span>-->

<!--      <div-->
<!--        class="alert-section"-->
<!--      >-->
<!--        <span class="alerts-counter">-->
<!--          <img-->
<!--            ngSrc="assets/icons/alert-triangle.svg" alt=""-->
<!--            width="18px"-->
<!--            height="18px"-->
<!--          >-->
<!--          {{ countInvalids(features) | json }}/{{ features.length }}-->
<!--        </span>-->

<!--        <div-->
<!--          class="alert-section-right"-->
<!--        >-->
<!--          <span class="alert-section-tittle">-->
<!--            System template future group-->
<!--          </span>-->

<!--          <ul-->
<!--            class="danger-list"-->
<!--          >-->
<!--            <ng-container-->
<!--              *ngFor="let feature of features"-->
<!--            >-->
<!--              <li-->
<!--                class="danger-list__item"-->
<!--                *ngIf="!feature?.isValid"-->
<!--              >-->
<!--                {{ feature.tittle }}-->
<!--              </li>-->
<!--            </ng-container>-->
<!--          </ul>-->
<!--        </div>-->
<!--      </div>-->


<!--    </div>-->
<!--  </div>-->
<!--</div>-->

<ng-container>
  <div class="dam-tab-grid">
    <div class="" [ngClass]="isOpened ? '':'hidden-center'">
      <div class="template-left">
        <div class="chek-template" style="display: none">
          <label>Выбранный шаблон</label>
          <label *ngIf="selectedTemplate">#{{ selectedTemplate.id }}</label>
        </div>
        <div class="template-left__name" style="display: none">
          <ng-select
            [items]="templates$ | async"
            bindLabel="header"
            bindValue="id"
            [minTermLength]="2"
            [compareWith]="compareTemplates"
            [loading]="loadingTemplates"
            [typeahead]="templateInput$"
            [clearable]="false"
            (change)="changeSelectedTemplate($event)"
            [(ngModel)]="selectedTemplate"
            typeToSearchText="Пожалуйста, введите 2 или более символов"
            i18n-typeToSearchText="@@TemplateAutocompleteTypeToSearchText"
            placeholder="Введите название шаблона"
            i18n-placeholder="@@TemplateAutocompleteLabel"
          >
          </ng-select>
        </div>


        <nb-accordion
          multi
          class="template-left__properties"
          *ngIf="bindedTemplate && bindedTemplate.groups"
        >
          <nb-accordion-item
            *ngFor="let fieldsGroup of bindedTemplate.groups; let groupIndex = index;"
            #groupItem
            id="groupItem_{{groupIndex}}"
            [expanded]="true"
          >
            <nb-accordion-item-header id="glava1" name="glava1">
              <div class="section-tittle">{{ fieldsGroup.header }}</div>

              <ng-container *ngIf="isGroupFilled(fieldsGroup.id)">
								<span class="state-success">
									{{ allFeaturesInGroup(fieldsGroup.id) }} из {{ allFeaturesInGroup(fieldsGroup.id) }}
								</span>
                <img src="/assets/images/product/check.svg" alt=""/>
              </ng-container>

              <ng-container *ngIf="isGroupNotFilled(fieldsGroup.id)">
								<span class="state-warn">
									{{ emptyFeaturesInGroup(fieldsGroup.id) }} из {{ allFeaturesInGroup(fieldsGroup.id) }}
								</span>
                <img src="/assets/images/product/znak.svg" alt=""/>
              </ng-container>
              <a
                name="glava1"
                [routerLink]="['/cabinet/pim/feature-group/edit/', fieldsGroup.groupId]"
                target="_blank"
                class="entityID"
                i18n-nbTooltip="@@OpenFeatureGroupInNewWindow"
                nbTooltip="Открыть группу в новом окне"
              >
                #{{ fieldsGroup.groupId }}
              </a>
            </nb-accordion-item-header>
            <nb-accordion-item-body>
              <ng-container *ngFor="let feature of fieldsGroup.features">
                <div class="tf-divider"></div>
                <app-tf-select
                  *ngIf="isSelectableFeatureType(feature.featureTypeId)"
                  [feature]="feature"
                  [featureLink]="true"
                  class="accordion-item"
                ></app-tf-select>
                <app-tf-range
                  *ngIf="isRangeFeatureType(feature.featureTypeId)"
                  [feature]="feature"
                  [featureLink]="true"
                  class="accordion-item"
                ></app-tf-range>
                <app-tf-boolean
                  *ngIf="isBooleanFeatureType(feature.featureTypeId)"
                  [feature]="feature"
                  [featureLink]="true"
                  class="accordion-item"
                ></app-tf-boolean>
                <app-tf-interval
                  *ngIf="isIntervalFeatureType(feature.featureTypeId)"
                  [feature]="feature"
                  [featureLink]="true"
                  class="accordion-item"
                ></app-tf-interval>
                <app-tf-string
                  *ngIf="isStringFeatureType(feature.featureTypeId) || isIconFeatureType(feature.featureTypeId) || isUnhandledFeatureType(feature.featureTypeId, feature.featureTypeCode)"
                  [feature]="feature"
                  [featureLink]="true"
                  class="accordion-item"
                ></app-tf-string>
                <app-tf-date
                  *ngIf="isDateFeatureType(feature.featureTypeId, feature.featureTypeCode)"
                  [feature]="feature"
                  [featureLink]="true"
                  class="accordion-item"
                ></app-tf-date>
                <app-tf-html
                  *ngIf="isHtmlFeatureType(feature.featureTypeId)"
                  [feature]="feature"
                  [featureLink]="true"
                  class="accordion-item"
                ></app-tf-html>
                <app-tf-size
                  *ngIf="isSizeFeatureType(feature.featureTypeId)"
                  [feature]="feature"
                  [featureLink]="true"
                  class="accordion-item"
                ></app-tf-size>
                <app-tf-link
                  *ngIf="isLinkFeatureType(feature.featureTypeId)"
                  [feature]="feature"
                  [featureLink]="true"
                  class="accordion-item"
                ></app-tf-link>
                <app-tf-smartlist
                  *ngIf="isSmartlistFeatureType(feature.featureTypeId)"
                  [feature]="feature"
                  [featureLink]="true"
                  class="accordion-item"
                ></app-tf-smartlist>
              </ng-container>
            </nb-accordion-item-body>
          </nb-accordion-item>
        </nb-accordion>

        <div class="tf-buttons form-feature-card">
          <button
            nbButton
            status="primary"
            type="button"
            [disabled]="!productFeatureStatus || productFeatureStatus.error || !modelFeaturesChanges"
            (click)="saveFeatureModel()"
            i18n="@@Save"
          >
            Сохранить изменения
          </button>

          <button
            *ngIf="isModal"
            (click)="modalClose()"
            nbButton
            status="basic"
            type="button"
            i18n="@@Close"
          >
            Закрыть
          </button>

          <button (click)="back()" nbButton status="basic" type="button" i18n>
            Отмена
          </button>

          <button
            nbButton
            type="button"
            i18n
            status="danger"
            *ngIf="productFeatureStatus && productFeatureStatus.empty"
          >
            <img src="/assets/images/product/znak.svg" alt=""/> {{ productFeatureStatus.empty }} не
            заполненных полей
          </button>
        </div>
      </div>
    </div>
    <div class="template-features__wrap section g-16" [ngClass]="isOpened ? '':'hidden-center'">
      <!--        <div-->
      <!--          class="close-nav"-->
      <!--          nbTooltip="{{ isOpened ? 'Скрыть колонку':'Показать колонку' }} "-->
      <!--          title="{{ isOpened ? 'скрыть колонку':'показать колонку' }}"-->
      <!--          (click)="toggleOpened()"-->
      <!--        >-->
      <!--          <img src="assets/images/catalog-icon.svg" alt=""/>-->
      <!--        </div>-->
      <div class="">
        <span class="section-tittle" *ngIf="selectedTemplate">{{ selectedTemplate.header }}</span>
        <span *ngIf="selectedTemplate">
            <a class="tf-go-to-template"
               [routerLink]="['/cabinet/pim/template-group/item/edit', selectedTemplate.id]"
               target="_blank"
            >
              <nb-icon icon="external-link-outline"/>
            </a>
          </span>
      </div>

      <div class="last-changes">

        Последние изменения:&nbsp;
        <span *ngIf="model.updatedAt">{{ model.updatedAt | date: 'dd.MM.yyyy HH:mm:ss' }}</span>
        <span *ngIf="!model.updatedAt && createdDate">
							{{ createdDate | date: 'dd.MM.yyyy HH:mm:ss' }}
						</span>

      </div>
      <div class="template-right template-right__scroll" *ngIf="isOpened">
        <div class="template-right__top">
          <div class="tf-buttons">
            <button
              [disabled]="!productFeatureStatus || productFeatureStatus.error || !modelFeaturesChanges"
              (click)="saveFeatureModel()"
              nbButton
              status="primary"
              type="submit"
              i18n
            >
              Сохранить изменения
            </button>
            <button
              (click)="back()"
              nbButton
              status="basic"
              type="button"
              i18n
            >
              Отмена
            </button>
          </div>

          <div class="productCopyForm mt-4">
            <form [formGroup]="baseProductIdForm" (ngSubmit)="copyFeatureValues()">
              <nb-form-field>
                <input
                  type="text"
                  formControlName="productId"
                  nbInput
                  fieldSize="small"
                  placeholder="Введите ID для копирования"
                />
                <button
                  nbSuffix
                  nbButton
                  ghost
                  type="submit"
                  [disabled]="baseProductIdForm.invalid"
                >
                  <nb-icon [icon]="'copy-outline'" pack="eva"></nb-icon>
                </button>
              </nb-form-field>
            </form>
          </div>
        </div>
        <div class="template-right__content " *ngIf="bindedTemplate">
          <!--          <a  class="template-right__content-item pointer" [class.item-respect]="isGroupNotFilled(group.id)"-->
          <!--               *ngFor="let group of bindedTemplate.groups; let groupIndex = index;" (click)="scrollToGroup(groupIndex)">-->
          <a
            (click)="scrollToGroup(groupIndex)"
            class="template-right__content-item pointer"
            [class.item-respect]="isGroupNotFilled(group.id)"
            *ngFor="let group of bindedTemplate.groups; let groupIndex = index;"
          >
            {{ group.header }}

            <span *ngIf="isGroupNotFilled(group.id)"> <nb-icon icon="alert-triangle-outline" status="warning"/>
              {{ emptyFeaturesInGroup(group.id) }} из {{ allFeaturesInGroup(group.id) }}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</ng-container>
